<template>
  <v-card-text class="pa-0 dialler-referral-height">
    <v-stepper vertical v-model="step" class="elevation-0">
      <v-stepper-step
        :step="steps.contact"
        :complete="step > steps.contact"
        :rules="[() => valid[1]]"
        error-icon="priority_high"
        complete-icon="done"
        edit-icon="done"
        editable
      >
        Contact Details
        <small>The primary contact for the business</small>
      </v-stepper-step>
      <v-stepper-content :step="steps.contact" class="pt-0">
        <v-form class="mt-2" ref="step1ref" v-model="valid[1]" lazy-validation>
          <v-card flat tile class="ma-0 mb-5">
            <v-card-text class="pa-0">
              <v-container fluid class="pa-0">
                <v-row no-gutters class="pt-0">
                  <v-col :cols="colsWidth" class="pt-0">
                    <v-container fluid class="pa-0">
                      <v-layout wrap>
                        <v-col cols="12" xs="12" sm="2" >
                          <v-select
                            :items="titles"
                            :label="'Title *'"
                            v-model="titleSelect"
                            :rules="[value => !!value || 'This field is required']"
                            required
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="2" v-if="showTitleInput">
                          <v-text-field
                            label="Title *"
                            v-model="title"
                            :rules="[value => !!value || 'This field is required']"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col v-bind="vColNameProps">
                          <v-text-field
                            label="First name *"
                            v-model="firstName"
                            :rules="[value => !!value || 'This field is required']"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col v-bind="vColNameProps">
                          <v-text-field
                            label="Last name *"
                            v-model="lastName"
                            :rules="[value => !!value || 'This field is required']"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" class="pt-0">
                          <v-text-field
                            label="Email *"
                            v-model="verifiedEmail"
                            :rules="emailRules"
                            :error-messages="emailErrorMessage"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" class="pt-0">
                          <v-text-field
                            label="Phone *"
                            v-model="phone"
                            :rules="[value => !!value || 'This field is required']"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-layout>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
          <v-btn color="accent" @click.native="(step = 2) && validateSteps(2)" :disabled="!valid[1]">Continue</v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step
        @click.native="validateSteps(2)"
        :step="steps.chooseBusiness"
        :complete="step > steps.chooseBusiness"
        :rules="[() => valid[2]]"
        error-icon="priority_high"
        complete-icon="done"
        edit-icon="done"
        editable
      >
        Business Name & Address
        <small>Search for the name/address or enter manually</small>
      </v-stepper-step>
      <v-stepper-content :step="steps.chooseBusiness" class="pl-2 pt-0">
        <v-form ref="step2ref" v-model="valid[2]" lazy-validation>
          <v-container fluid grid-list-md class="pa-0 mb-5">
            <v-row no-gutters>
              <v-col :cols="colsWidth">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-switch label="Limited Company" v-model="isLimited" hide-details></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="isLimited">
                    <v-autocomplete
                      v-model="companiesHouse"
                      :items="businesses"
                      :search-input.sync="companiesHouseSearch"
                      hide-no-data
                      item-text="title"
                      item-value="API"
                      label="Company name"
                      return-object
                      prepend-icon="fad fa-search"
                      :no-filter="true"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.title"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.address_snippet"></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 v-if="!isLimited">
                    <v-autocomplete
                      v-model="loqateQuery"
                      :items="loqate"
                      :search-input.sync="loqateQuerySearch"
                      hide-no-data
                      item-text="Text"
                      item-value="API"
                      label="Company name or address"
                      return-object
                      prepend-icon="fad fa-search"
                      :no-filter="true"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.Text"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.Description"></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 v-if="!isLimited && showAddressSelect">
                    <v-select
                      v-model="selectedAddress"
                      :items="loqateOptions"
                      placeholder="Select an address"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.CommercialName !== null">
                    <v-text-field
                      label="Company Name *"
                      v-model="business.CommercialName"
                      :rules="[value => !!value || 'This field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessRef !== null">
                    <v-text-field
                      v-if="isLimited"
                      label="Company Number *"
                      v-model="business.BusinessRef"
                      :rules="[value => !!value || 'This field is required']"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-if="!isLimited"
                      label="Company Reference *"
                      v-model="business.BusinessRef"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                    <v-text-field
                      label="Address Line 1 *"
                      v-model.trim="business.BusinessLocation.LocationLine1"
                      :rules="[value => !!value || 'This field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                    <v-text-field label="Address Line 2" v-model.trim="business.BusinessLocation.LocationLine2">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                    <v-text-field
                      label="City *"
                      v-model.trim="business.BusinessLocation.LocationLine3"
                      :rules="[value => !!value || 'This field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                    <v-text-field label="Address Line 4" v-model.trim="business.BusinessLocation.LocationLine4">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                    <v-text-field label="Address Line 5" v-model.trim="business.BusinessLocation.LocationLine5">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="business.BusinessLocation.LocationLine1 !== null">
                    <v-text-field
                      label="Postcode *"
                      v-model.trim="business.BusinessLocation.Postcode"
                      :rules="[
                        value => !!value || 'This field is required',
                        value => value.length <= 8 || 'Postcode may not be greater than 8 characters'
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <!--                <v-btn text color="pink" @click="manualAddress = false" v-if="!experianError"-->
                  <!--                  >Select address from Experian list</v-btn-->
                  <!--                >-->
                </v-layout>
              </v-col>
            </v-row>
          </v-container>
          <v-btn color="accent" @click.native="(step = 3) && validateSteps(3)" :disabled="!valid[2]">Continue</v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step
        @click.native="validateSteps(3)"
        :step="steps.initialQuestions"
        :complete="step > steps.initialQuestions"
        :rules="[() => valid[3]]"
        error-icon="priority_high"
        complete-icon="done"
        edit-icon="done"
        editable
        >Initial Questions <small>Determines SME journey</small>
      </v-stepper-step>
      <v-stepper-content :step="steps.initialQuestions" class="pl-2 pt-0">
        <v-form ref="step3ref" v-model="valid[3]" lazy-validation>
          <question-group-list :group="initialQuestionGroup"></question-group-list>
          <v-btn class="my-4" color="accent" @click.native="(step = 4) && validateSteps(3)" :disabled="!valid[3]">
            Continue
          </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step v-if="showReferralStep" :step="steps.addReferral" :complete="step > steps.addReferral" editable
        >Referral <small>Select a referrer if required</small></v-stepper-step
      >
      <v-stepper-content v-if="showReferralStep" :step="steps.addReferral" class="pl-2">
        <v-flex xs4>
          <v-card flat class="mb-5">
            <v-flex xs12 sm6>
              <v-autocomplete
                :items="RegistrationReferrerList"
                item-text="name"
                item-value="id"
                v-model="referral.business"
                label="Referring business"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-switch label="Send referral email" v-model="referral.email"></v-switch>
            </v-flex>
          </v-card>
        </v-flex>
        <v-btn color="accent" @click.native="(step = 5) && $refs.step3ref.validate() && $refs.step2ref.validate()">
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        @click.native="validateSteps(3)"
        :step="steps.confirm"
        :complete="step > steps.confirm"
        error-icon="priority_high"
        complete-icon="done"
        edit-icon="done"
        editable
      >
        Confirm <small>Confirm the business details are correct</small>
      </v-stepper-step>
      <v-stepper-content :step="steps.confirm" class="pl-2 pt-0">
        <v-col :cols="colsWidth" class="pt-0">
          <v-card flat class="pa-0">
            <h3>{{ business.name }}</h3>
            <v-list dense class="transparent">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="pink">person</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ firstName }} {{ lastName }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="pink">email</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ email }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="pink">phone</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ phone }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-action>
                  <v-icon color="pink">location_on</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="business.BusinessLocation.LocationLine1"
                      >{{ startCase(business.BusinessLocation.LocationLine1) }}, </span
                    ><br />
                    <span v-if="business.BusinessLocation.LocationLine2"
                      >{{ startCase(business.BusinessLocation.LocationLine2) }},
                    </span>
                    <span v-if="business.BusinessLocation.LocationLine3"
                      >{{ startCase(business.BusinessLocation.LocationLine3) }},
                    </span>
                    <span v-if="business.BusinessLocation.LocationLine4"
                      >{{ startCase(business.BusinessLocation.LocationLine4) }},
                    </span>
                    <span v-if="business.BusinessLocation.LocationLine5"
                      >{{ startCase(business.BusinessLocation.LocationLine5) }},
                    </span>
                    {{ business.BusinessLocation.Postcode }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="my-4"></v-divider>
            </v-list>
            <v-layout>
              <v-flex xs4 v-if="!UserHasRole('Broker')">
                <v-switch label="Quick Submit" v-model="auto_send_enquiries"></v-switch>
              </v-flex>
              <v-flex xs4>
                <v-switch label="Newsletter Signup" v-model="newsletter_signup"></v-switch>
              </v-flex>
              <v-flex xs4>
                <v-switch label="Soft Search Consent" v-model="soft_search_consent"></v-switch>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
        <v-btn
          color="accent"
          @click.native="prepareDetailsAndRegister"
          :disabled="!valid[1] || !valid[2] || !valid[3]"
        >
          Register
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        @click.native="validateSteps(3)"
        :step="steps.register"
        :complete="step > steps.register"
        :rules="[() => registrationSuccess !== false]"
        editable
      >
        Register
        <small v-if="registrationSuccess === false">There was a problem registering the business</small>
        <small v-else>Register the business</small>
      </v-stepper-step>
      <v-stepper-content :step="steps.register" class="pl-2 pt-0">
        <v-col :cols="colsWidth">
          <v-card flat class="pa-0">
            <v-progress-linear indeterminate color="pink" size="64" v-if="RegistrationInProgress" />
            <v-card-text class="pa-0">
              <v-alert
                type="success"
                :value="registrationSuccess === true && RegistrationInProgress === false"
                outlined
              >
                <div class="mb-2">Customer has been successfully registered.</div>
                <div class="mb-1">Creating the answer set...</div>
                <v-progress-linear color="success" indeterminate></v-progress-linear>
              </v-alert>
              <v-alert type="error" :value="registrationSuccess === false && RegistrationInProgress === false" outlined>
                There was a problem registering the customer<br />
                {{ registrationError }}
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
        <v-btn color="accent" @click.native="closeDialog" v-if="!dialler">Finish</v-btn>
      </v-stepper-content>
    </v-stepper>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import QuestionGroupList from '../OverviewDrawer/Answers/QuestionGroupList';
import { emailRules } from '@/utils/validators';
import companiesHouse from '@/api/companiesHouse';
import loqate from '@/api/loqate';

export default {
  name: 'customer-registration',
  components: { QuestionGroupList },
  props: {
    referralDetails: {
      type: Object,
      default: null
    },
    phoneCallId: {
      type: String,
      default: null
    },
    dialler: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    step: 1,
    steps: {
      contact: 1,
      chooseBusiness: 2,
      initialQuestions: 3,
      addReferral: 0,
      confirm: 4,
      register: 5
    },
    valid: [true, true, true, true, true, true],
    emptyGroup: {
      questions: []
    },
    showReferralStep: false,
    business: {
      BusinessRef: null,
      RegisteredCompanySicCodes: null,
      CommercialName: null,
      BusinessLocation: {
        LocationLine1: null,
        LocationLine2: null,
        LocationLine3: null,
        LocationLine4: null,
        LocationLine5: null,
        City: null,
        Postcode: null
      }
    },
    referral: {
      partner: null,
      funder: null,
      sendEmail: false
    },
    referral_id: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    businessName: null,
    postcode: null,
    isLimited: true,
    businessCheckTried: false,
    manualAddress: true,
    registrationSuccess: null,
    registrationError: null,
    newsletter_signup: false,
    auto_send_enquiries: false,
    soft_search_consent: false,
    experianError: false,
    companiesHouse: null,
    companiesHouseSearch: null,
    loqateQuery: null,
    lastLoqateQuery: null,
    loqateQuerySearch: null,
    loqateQueryName: null,
    loqateQueryNameSearch: null,
    showAddressSelect: false,
    businesses: [],
    loqate: [],
    selectedAddress: null,
    searching: false,
    emailRules,
    titles: ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Other'],
    title: null,
    showTitleInput: undefined,
    selectedTitle: undefined
  }),
  computed: {
    ...mapGetters([
      'RegistrationReferrerList',
      'RegistrationEmailExists',
      'RegistrationBusinessExists',
      'RegistrationExperianList',
      'RegistrationWaitingForExperian',
      'RegistrationInProgress',
      'RegistrationAnswers',
      'RegistrationQuestionCount',
      'SelectedReferral',
      'UserHasRole',
      'UserBusinesses',
      'JourneyTypes'
    ]),
    emailErrorMessage() {
      return this.RegistrationEmailExists ? ['Email address is already registered'] : [];
    },
    businessErrorMessage() {
      return this.RegistrationBusinessExists ? ['Business is already registered'] : [];
    },
    colsWidth() {
      return 12;
    },
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    businessDetailsComplete() {
      if (this.businessCheckTried) {
        return !_.isEmpty(this.businessName) && !_.isEmpty(this.postcode);
      }
      return true;
    },
    verifiedEmail: {
      get() {
        return this.email;
      },
      set: _.debounce(function(email) {
        this.email = email;
        this.verifyRegistrationEmail(email);
      }, 500)
    },
    initialQuestionGroup() {
      return _.isNull(this.JourneyTypes[0].id) ? this.emptyGroup : this.JourneyTypes[0].journeys[0].question_groups[0];
    },
    initialQuestionsComplete() {
      console.log(JSON.stringify(this.RegistrationAnswers, null, 2));
      console.log(this.RegistrationQuestionCount);
      return this.RegistrationAnswers.length === this.RegistrationQuestionCount;
    },
    loqateOptions: function() {
      return [
        { value: null, text: 'Select an address', disabled: true },
        ...this.loqate.map(address => {
          return { value: address.Id, text: `${address.Text}, ${address.Description}` };
        })
      ];
    },
    titleSelect: {
      get: function () {
        if (this.selectedTitle === undefined && this.title) {
          return this.titles.includes(this.title) ?
            this.title : 'Other'
        }
        return this.selectedTitle
      },
      set: function (value) {
        this.selectedTitle = value
      },
    },
    vColNameProps: function() {
      if (this.showTitleInput) {
        return {
          cols: '12',
          xs: '12',
          sm: '4'
        };
      } else {
        return {
          cols: '12',
          xs: '12',
          sm: '5'
        };
      }
    }
  },
  methods: {
    ...mapActions([
      'getRegistrationReferrerList',
      'verifyRegistrationEmail',
      'verifyRegistrationBusiness',
      'getExperianList',
      'clearRegistration',
      'clearSelectedCustomer',
      'addNotification',
      'registerBusiness',
      'setCustomerPageFilters',
      'setCustomerSearch',
      'getReferralsPage',
      'getCustomerPage',
      'getJourneyTypes',
      'setPhoneCallAsRegistered'
    ]),
    closeDialog() {
      if (this.UserHasRole('Broker')) {
        this.getReferralsPage();
      }
      this.clearRegistration();
      this.dialog = false;
    },
    // lookupBusiness() {
    //   this.experianError = false;
    //   this.businessCheckTried = true;
    //   this.business.CommericalName = this.businessName;
    //   this.business.BusinessLocation.Postcode = this.postcode;
    //
    //   if (this.businessDetailsComplete) {
    //     const { businessName, postcode, isLimited } = this;
    //     this.getExperianList({ businessName, postcode, isLimited })
    //       .then(experianList => {
    //         if (experianList.length === 0) {
    //           this.manualAddress = true;
    //         }
    //       })
    //       .catch(() => {
    //         this.manualAddress = true;
    //         this.experianError = true;
    //       });
    //     this.step = this.steps.chooseBusiness;
    //   } else {
    //     this.addNotification({
    //       text: 'Business name and postcode are both required',
    //       bottom: true,
    //       left: true,
    //       colour: 'red'
    //     });
    //   }
    // },
    // selectBusiness(index) {
    //   this.business = this.RegistrationExperianList[index];
    //   // this.verifyRegistrationBusiness(this.business.BusinessRef);
    //   this.manualAddress = true;
    // },
    searchCompaniesHouse: function(q) {
      companiesHouse.searchCompanies(q, 10, 0).then(result => (this.businesses = result.items));
    },
    searchLoqate: function(q) {
      if (!this.searching) {
        this.showAddressSelect = false;
        loqate.search(q).then(result => {
          if (result.Items.length === 1 && result.Items[0].Type === 'Postcode') {
            this.selectLoqateBusiness(result.Items[0]);
          } else {
            this.loqate = result.Items;
          }
        });
      }
    },
    selectBusiness: async function(business) {
      business.sic_codes = await companiesHouse.getSicCodes(business.company_number).catch(() => null);
      business.sic_codes = business.sic_codes ? JSON.stringify(business.sic_codes) : null;

      this.business = {
        BusinessRef: business.company_number,
        RegisteredCompanySicCodes: business.sic_codes,
        CommercialName: business.title,
        BusinessLocation: {
          LocationLine1: `${business.address.premises}, ${business.address.address_line_1}`,
          LocationLine2: business.address.address_line_2,
          LocationLine3: business.address.locality,
          LocationLine4: business.address.region,
          LocationLine5: null,
          City: business.address.locality,
          Postcode: business.address.postal_code
        }
      };
      this.manualAddress = true;
    },
    selectLoqateBusiness: function(business) {
      this.showAddressSelect = false;
      this.searching = true;
      if (typeof business === 'string') {
        business = { Id: business, Type: null };
      }
      if (business.Type === 'Postcode') {
        loqate.searchContainer(business.Text, business.Id).then(result => {
          this.loqate = result.Items;
          this.showAddressSelect = true;
        });
      } else {
        loqate.retrieve(business.Id).then(
          response =>
            (this.business = {
              BusinessRef: response.Items[0].Id,
              CommercialName: response.Items[0].Company,
              BusinessLocation: {
                LocationLine1: response.Items[0].Line1,
                LocationLine2: response.Items[0].District,
                LocationLine3: response.Items[0].City,
                LocationLine4: response.Items[0].Province,
                LocationLine5: null,
                City: response.Items[0].City,
                Postcode: response.Items[0].PostalCode
              }
            })
        );

        this.showManualAddress = true;
        this.showSearchBox = false;
      }
      this.searching = false;
    },
    prepareDetailsAndRegister() {
      this.registrationSuccess = null;
      this.step = this.steps.register;
      const details = {
        title: this.title,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        isLimited: this.isLimited,
        newsletter_signup: this.newsletter_signup,
        auto_send_enquiries: this.auto_send_enquiries,
        soft_search_consent: this.soft_search_consent,
        referral_id: this.referral_id,
        business: {
          commercialName: this.business.CommercialName,
          businessRef: this.business.BusinessRef,
          registeredCompanySicCodes: this.business.RegisteredCompanySicCodes,
          businessLocation: {
            locationLine1: this.business.BusinessLocation.LocationLine1,
            locationLine2: this.business.BusinessLocation.LocationLine2,
            locationLine3: this.business.BusinessLocation.LocationLine3,
            locationLine4: this.business.BusinessLocation.LocationLine4,
            locationLine5: this.business.BusinessLocation.LocationLine5,
            city: this.business.BusinessLocation.City || this.business.BusinessLocation.LocationLine3,
            postcode: this.business.BusinessLocation.Postcode
          }
        },
        referrer_id: this.UserHasRole('Broker') ? this.UserBusinesses[0] : this.referral.business,
        sendEmail: this.referral.sendEmail,
        answers: this.RegistrationAnswers
      };
      this.registerBusiness(details)
        .then(customer => {
          this.registrationSuccess = true;
          setTimeout(() => {
            this.getCustomerPage();
            if (this.dialler) {
              this.setPhoneCallAsRegistered({
                phoneCallId: this.phoneCallId,
                businessId: customer.business_id,
                businessName: this.business.CommercialName,
                contact: `${this.firstName} ${this.lastName}`
              });
            } else {
              this.$router.push(`/customers/${customer.business_id}`);
            }
          }, 3000);
        })
        .catch(error => {
          console.log(error);
          this.registrationSuccess = false;
          this.registrationError = error.message;
        });
    },
    startCase(str) {
      const lowerCaseStr = _.lowerCase(str);
      return _.startCase(lowerCaseStr);
    },
    isDefined(value) {
      return _.isUndefined(value) === false;
    },
    isFilled(value) {
      return !_.isEmpty(value);
    },
    calculateSteps() {
      if (!this.isFilled(this.referralDetails) && this.UserHasRole('Platform')) {
        this.steps = {
          contact: 1,
          chooseBusiness: 2,
          initialQuestions: 3,
          addReferral: 4,
          confirm: 5,
          register: 6
        };
        this.showReferralStep = true;
      }
    },
    setReferralDetails() {
      if (!_.isEmpty(this.referralDetails)) {
        this.step = 1;

        this.referral_id = this.referralDetails.id;

        this.firstName = this.referralDetails.first_name;
        this.lastName = this.referralDetails.last_name;
        this.email = this.referralDetails.email;
        this.phone = this.referralDetails.phone;

        // this.businessName = this.referralDetails.company_name;
        // this.postcode = this.referralDetails.address.post_code;

        this.business.BusinessRef = '';
        this.business.CommercialName = this.referralDetails.company_name;

        this.business.BusinessLocation = {
          LocationLine1: this.referralDetails.address.line_1,
          LocationLine2: this.referralDetails.address.line_2,
          LocationLine3: this.referralDetails.address.line_3,
          LocationLine4: this.referralDetails.address.line_4,
          LocationLine5: this.referralDetails.address.line_5,
          Postcode: this.referralDetails.address.post_code.replace(',', '')
        };
      }

      if (this.email) {
        this.verifyRegistrationEmail(this.email);
      }
    },
    validateSteps: function(upToStep) {
      for (let i = upToStep; i > 0; i--) {
        // Validating simultaneously not working, hence setTimeout
        setTimeout(this.$refs[`step${i}ref`].validate, i * 200);
      }
    },
  },
  mounted() {
    if (_.isEmpty(this.referralDetails)) {
      this.getRegistrationReferrerList();
    }
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
    this.clearSelectedCustomer();
    this.calculateSteps();
    this.setReferralDetails();
  },
  watch: {
    companiesHouseSearch: _.debounce(function(newQuery) {
      this.searchCompaniesHouse(newQuery);
    }, 250),
    companiesHouse: function(business) {
      this.selectBusiness(business);
    },
    loqateQuery: function(business) {
      this.selectLoqateBusiness(business);
    },
    loqateQuerySearch: _.debounce(function(newQuery = '', oldQuery = '') {
      if (newQuery.length < 3) {
        this.loqate = [];
      } else if (newQuery.toLowerCase() !== oldQuery.toLowerCase() && newQuery !== this.lastLoqateQuery) {
        this.searchLoqate(newQuery);
        this.lastLoqateQuery = newQuery;
      }
    }, 250),
    loqateQueryNameSearch: _.debounce(function(newQuery = '', oldQuery = '') {
      if (newQuery.length < 3) {
        this.loqate = [];
      } else if (newQuery.toLowerCase() !== oldQuery.toLowerCase()) {
        this.searchLoqate(newQuery);
      }
    }, 250),
    selectedAddress: function(id) {
      this.selectLoqateBusiness(id);
    },
    titleSelect: function() {
      if (this.selectedTitle === undefined) {
        this.selectedTitle = this.titleSelect
      }
      if (this.selectedTitle === 'Other') {
        if (this.titles.includes(this.title)) {
          this.title = ''
        }
        this.showTitleInput = true
      } else {
        this.title = this.selectedTitle
        this.showTitleInput = false
      }
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-stepper__step {
    .v-stepper__step__step .v-icon {
      font-size: 1rem;
    }
    &.v-stepper__step--error .v-stepper__step__step {
      background: var(--v-error-base);

      .v-icon {
        color: white;
      }
    }

    &.v-stepper__step--complete {
      .v-stepper__step__step.primary {
        background-color: var(--v-accent-base) !important;
      }

      &.v-stepper__step--error .v-stepper__label {
        color: var(--v-error-base);
      }
    }
  }

  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}
.dialler-referral-height {
  height: calc(97vh);
  max-height: calc(97vh);
  overflow-y: auto;
}

address {
  font-style: normal;
}
</style>
